import { ALL_HIGHLIGHTS_ID } from '@hotjar/webapp/domains/collections/model';

export function getHighlightUrl(siteId: string, highlightId: string): string {
  const url = new URL(
    `https://${window.location.host}/sites/${siteId}/highlights/${ALL_HIGHLIGHTS_ID}`,
  );
  url.searchParams.append('highlight', highlightId);
  return url.toString();
}
